import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import { connect } from 'react-redux';

import { getAllBrands as getAllBrandsAction } from '../ReduxToolkit/Reducers/brands';
import { getAllRetailers as getAllRetailersAction } from '../ReduxToolkit/Reducers/retailers';
import {
  checkOrganizationExist as checkOrganizationExistAction,
  setupPittiBrandRetailerAccount as setupPittiBrandRetailerAccountAction,
  setupPittiBrandRetailerAccountBulk as setupPittiBrandRetailerAccountBulkAction,
} from '../ReduxToolkit/Reducers/organizationManagement';
import PittiInvitedOrganizationsTab from '../Components/PittiInvitedOrganizationsTab';
import ManualInviteTab from '../Components/PittiInvite/ManualInviteTab';
import BulkInviteTab from '../Components/PittiInvite/BulkInviteTab';

function PittiInvite({
  setupPittiBrandRetailerAccount,
  setupPittiBrandRetailerAccountBulk,
  getAllBrands,
  getAllRetailers,
  checkOrganizationExist,
}) {
  const [activeTab, setActiveTab] = useState('1');
  const [inviteSubTab, setInviteSubTab] = useState('manual');

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const toggleInviteSubTab = (tab) => {
    if (inviteSubTab !== tab) {
      setInviteSubTab(tab);
    }
  };

  const handleInviteSuccess = () => {
    setActiveTab('2');
  };

  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <Col sm={12}>
            {/* Main Tabs */}
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeTab === '1' ? 'active' : ''}
                  onClick={() => toggleTab('1')}
                  style={{ cursor: 'pointer' }}
                >
                  Pitti Invite
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === '2' ? 'active' : ''}
                  onClick={() => toggleTab('2')}
                  style={{ cursor: 'pointer' }}
                >
                  Invited Organizations
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent activeTab={activeTab}>
              {/* Pitti Invite Tab */}
              <TabPane tabId="1">
                {activeTab === '1' && (
                  <div className="mt-3">
                    {/* Sub-tabs: Manual / Import CSV */}
                    <Nav pills className="mb-3">
                      <NavItem>
                        <NavLink
                          className={inviteSubTab === 'manual' ? 'active' : ''}
                          onClick={() => toggleInviteSubTab('manual')}
                          style={{ cursor: 'pointer', fontSize: '14px' }}
                        >
                          Invite Manually
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={inviteSubTab === 'bulk' ? 'active' : ''}
                          onClick={() => toggleInviteSubTab('bulk')}
                          style={{ cursor: 'pointer', fontSize: '14px' }}
                        >
                          Import CSV
                        </NavLink>
                      </NavItem>
                    </Nav>

                    {inviteSubTab === 'manual' && (
                      <ManualInviteTab
                        setupPittiBrandRetailerAccount={setupPittiBrandRetailerAccount}
                        getAllBrands={getAllBrands}
                        getAllRetailers={getAllRetailers}
                        checkOrganizationExist={checkOrganizationExist}
                        onSuccess={handleInviteSuccess}
                      />
                    )}

                    {inviteSubTab === 'bulk' && (
                      <BulkInviteTab
                        setupPittiBrandRetailerAccountBulk={setupPittiBrandRetailerAccountBulk}
                        onSuccess={handleInviteSuccess}
                      />
                    )}
                  </div>
                )}
              </TabPane>

              {/* Invited Organizations Tab */}
              <TabPane tabId="2">
                {activeTab === '2' && <PittiInvitedOrganizationsTab />}
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const mapDispatchToProps = {
  setupPittiBrandRetailerAccount: setupPittiBrandRetailerAccountAction,
  setupPittiBrandRetailerAccountBulk: setupPittiBrandRetailerAccountBulkAction,
  getAllBrands: getAllBrandsAction,
  getAllRetailers: getAllRetailersAction,
  checkOrganizationExist: checkOrganizationExistAction,
};

export default connect(null, mapDispatchToProps)(PittiInvite);
